import { Pipe, PipeTransform } from '@angular/core';

// SERVICES
import { CardUtilService } from '../../services/util/card-util.service';

@Pipe({
  name: 'maskCardNumber',
})
export class MaskCardNumberPipe implements PipeTransform {
  constructor(private cardUtilService :CardUtilService) {}

  transform(cardNumber :string) :string {
    return `**** **** ***${this.cardUtilService.getLastDigitFormat(cardNumber)}`;
  }
}
